<template>
  <v-container
    id="boss"
    tag="section"
  >
    <base-card
      color="rgba(0, 0, 0, 0)"
      class="pa-3"
    >
      <v-container
        grid-list-xl
        pa-0
      >
        <v-layout wrap>
          <v-flex
            xs12
            md5
          >
            <base-subheading class="mb-3">
              Руководитель организации
            </base-subheading>
            <p style="font-size: 16px;">
              {{about.boss}}
            </p>

            <v-layout
              wrap
              pa-2
              style="overflow: hidden;"
            >
              <base-card dark>
                  <v-img
                    class="grey lighten-2"
                    height="300"
                    width="300"
                    src="/static/assets/boss.jpg"
                  >
                  </v-img>
                </base-card>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md6
            offset-md1
          >
            <base-subheading>Контакты</base-subheading>
            <v-list class="transparent" v-if="!isMobile">
              <v-list-tile style="height: 44px;">
                <v-list-tile-avatar
                  color="primary"
                >
                  <v-icon
                    class="elevation-4"
                    dark
                  >
                    mdi-phone
                  </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title style="width: 80px;">Тел.</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.boss_phone}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile style="height: 44px;">
                <v-list-tile-avatar
                  color="primary"
                >
                  <v-icon
                    class="elevation-4"
                    dark
                  >
                    mdi-email-outline
                  </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title style="width: 80px;">E-Mail</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.boss_email}}
                </v-list-tile-sub-title>
              </v-list-tile>
            </v-list>
            <div v-else>
              <span><b>Тел.:</b></span><br>
              <span>{{about.boss_phone}}</span><br>
              <span><b>E-Mail:</b></span><br>
              <span>{{about.boss_email}}</span>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </base-card>
  </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    data: function() {
      return {
        about: {},
        isMobile: false
      }
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    mounted () {
      this.onResize();
      window.addEventListener('resize', this.onResize, { passive: true });
      axios.get('/static/data/about.json')
        .then(response => {
          this.about = response.data
        }).catch(error => {
          console.log(error)
        });
    },
    methods: {
      onResize () {
        this.isMobile = window.innerWidth < 480;
      }
    }
  }
</script>
